<template>
  <form class="form" @submit.prevent="submit">
    <h2 class="form__title">Восстановление пароля</h2>
    <div class="form__description form__description_align-center">
      <p>
        Введите номер телефона, указанный при&nbsp;регистрации
      </p>
    </div>
    <div class="form-row form-row_no-flex">
      <text-input
        label="Телефон*"
        v-model="$v.form.phone.$model"
        @input="error = null"
        name="phone"
        type="tel"
        :error="$v.form.phone.$error"
      >
        <template #errors>
          <div class="text-input__error" v-if="$v.form.phone.$error">
            <div v-if="!$v.form.phone.required">
              Заполните поле
            </div>
            <div v-if="!$v.form.phone.phoneRegex">
              Неверный формат телефона
            </div>
          </div>
        </template>
      </text-input>
    </div>
    <smart-captcha ref="smartCaptcha" v-model="$v.form.captcha.$model">
      <template #errors>
        <div class="text-input__error">
          <div v-if="$v.form.captcha.$error">Необходимо пройти капчу</div>
        </div>
      </template>
    </smart-captcha>
    <div class="form__error-alert" v-show="hasError">
      Пожалуйста, проверьте правильность заполнения поля Телефон
    </div>
    <div class="reset-password__footer">
      <button
        class="reset-password__submit button button__lg button__blue"
        type="submit"
      >
        Продолжить
      </button>
      <ul class="reset-password__links">
        <li>
          Вспомнили пароль?
          <router-link :to="{ name: 'login' }" class="form__link">
            Войти
          </router-link>
        </li>
        <li>
          Нет аккаунта?
          <router-link :to="{ name: 'register' }" class="form__link">
            Зарегистрироваться
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'feedback' }" class="form__link">
            Написать нам
          </router-link>
        </li>
      </ul>
    </div>
  </form>
</template>

<script>
import {required, helpers} from "vuelidate/lib/validators";
import TextInput from "./TextInput";
import SmartCaptcha from "./SmartCaptcha.vue";
import api from "../services/api";
import SmartCaptchaMixin from "../mixins/smartCaptchaMixin";

const phoneRegex = helpers.regex(
  "val1",
  /^(\+)?(\(\d{2,3}\) ?\d|\d)(([ -]?\d)|( ?\(\d{2,3}\) ?)){5,12}\d$/
);

export default {
  name: "ResetPasswordStep1",
  mixins: [SmartCaptchaMixin],
  components: {
    SmartCaptcha,
    TextInput
  },
  data() {
    return {
      hasError: false,
      form: {
        phone: "",
        captcha: ""
      },
    };
  },
  validations() {
    const form = {
      phone: { required, phoneRegex },
      captcha: {required}
    }
    return { form };
  },
  methods: {
    async submit() {
      await this.refreshCaptcha();

      this.$v.form.$touch();
      this.hasError = this.$v.form.$invalid;
      if (!this.$v.form.$pending && !this.$v.form.$invalid) {
        this.$store.dispatch("showLoader");

        try {
          await api.resetPassword(this.form);
          this.$emit("complete", 2, this.form.phone);
          this.$store.dispatch("hideErrorsBag");
        } catch (e) {
          this.$store.dispatch("setErrors", e);
          await this.updateCaptchaOnError();
        } finally {
          this.$store.dispatch("hideLoader");
        }
      }
    },
  },
};
</script>
